import store from "../store.js";
import Vue from "vue";
import keviApi from "../keviApi";
import _ from "lodash";
const state = () => ({
    status: "loading",
    modalVisible: null,
    activeUser: null,
    activeBranch: null,
    users: [],
    branches: [],
    roles: [],
    whatsappInstances: [],
    senders: [],
    id: null,
    placeDetails: {
        logo: null,
        name: null,
        active: null,
    },
});

const getters = {
    getActiveUser(state) {
        let users = state.users;
        return users.find((u) => u.id === state.activeUser);
    },
    getActiveBranch(state) {
        let branches = state.branches;
        return branches.find((b) => b.id === state.activeBranch);
    },
};

const actions = {
    editUser({ commit }, id) {
        commit("set", { activeUser: id });
        commit("openModal", "user-form");
    },

    addUser({ commit }) {
        commit("set", { activeUser: null });
        commit("openModal", "user-form");
    },

    editBranch({ commit }, id) {
        commit("set", { activeBranch: id });
        commit("openModal", "branch-form");
    },

    addBranch({ commit }) {
        commit("set", { activeBranch: null });
        commit("openModal", "branch-form");
    },

    loadInfo({ commit, state }) {
        return new Promise((resolve, reject) => {
            let id = state.id;
            let options = keviApi.getOptions("place/" + id + "/details");
            Vue.http(options)
                .then((response) => {
                    commit("set", {
                        placeDetails: {
                            logo: response.body.logo,
                            name: response.body.name,
                            active: response.body.active === "1",
                            country_code: response.body.country_code || "BR",
                            automations_locked: response.body.automations_locked === "1",
                        },
                    });
                    resolve(response);
                })
                .catch((res) => reject(res));
        });
    },
    loadUsers({ commit, state }) {
        return new Promise((resolve, reject) => {
            let id = state.id;
            let options = keviApi.getOptions("place/" + id + "/users");
            Vue.http(options)
                .then((response) => {
                    commit("set", { users: response.body });
                    resolve(response);
                })
                .catch((res) => reject(res));
        });
    },
    loadWhatsappInstances({ commit, state }) {
        return new Promise((resolve, reject) => {
            let id = state.id;
            let options = keviApi.getOptions(
                "place/" + id + "/whatsappInstances?include_inactive=0",
            );
            Vue.http(options)
                .then((response) => {
                    commit("set", { whatsappInstances: response.body });
                    resolve(response);
                })
                .catch((res) => reject(res));
        });
    },
    loadSenders({ commit, state }) {
        return new Promise((resolve, reject) => {
            let id = state.id;
            let options = keviApi.getOptions("senders" + (id ? "?places_id=" + id : ""), "GET");
            Vue.http(options)
                .then((response) => {
                    commit("set", { senders: response.body.my_senders });
                    resolve(response);
                })
                .catch((res) => reject(res));
        });
    },
    loadBranches({ commit, state }) {
        return new Promise((resolve, reject) => {
            let id = state.id;
            let options = keviApi.getOptions("place/" + id + "/branches");
            Vue.http(options)
                .then((response) => {
                    commit("set", { branches: response.body });
                    resolve(response);
                })
                .catch((res) => reject(res));
        });
    },
    loadRoles({ commit, state }) {
        return new Promise((resolve, reject) => {
            let id = state.id;
            let options = keviApi.getOptions("place/" + id + "/roles");
            Vue.http(options)
                .then((response) => {
                    commit("set", { roles: response.body });
                    resolve(response);
                })
                .catch((res) => reject(res));
        });
    },
    setPlace({ commit, dispatch }, id) {
        commit("set", { id: id });
        return Promise.all([
            dispatch("loadUsers"),
            dispatch("loadWhatsappInstances"),
            dispatch("loadSenders"),
            dispatch("loadBranches"),
            dispatch("loadInfo"),
            dispatch("loadRoles"),
        ]);
    },
};

const mutations = {
    set(state, options) {
        for (let prop in options) {
            state[prop] = _.cloneDeep(options[prop]);
        }
    },
    openModal(state, modal) {
        if (modal === "user-form" || modal === "branch-form") {
            state.modalVisible = modal;
        } else {
            throw "Modal " + modal + " doesn't exist'";
        }
    },
    closeModal(state) {
        state.modalVisible = null;
        state.activeUser = null;
        state.activeBranch = null;
    },
};

store.registerModule("placeDetails", {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
});

export default store;
